module.exports = {
	"classes": [
		"identity-glossary"
	],
	"title": "Identity Glossary",
	"metas": {
		"description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure."
	},
	"opengraph": {
		"og:title": "Identity Glossary",
		"og:description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure.",
		"og:url": "https://auth0.com/identity-glossary",
		"og:image": "http://cdn2.auth0.com/blog/identity-glossary-twittercard.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/identity-glossary-twittercard.png"
	},
	"twittercard": {
		"twitter:title": "Identity Glossary",
		"twitter:description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure.",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/identity-glossary-twittercard.png"
			}
		]
	},
	"canonical": "/identity-glossary"
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/identity-glossary/metadata.json
// module id = 1396
// module chunks = 0